
/*
 * UNBEGUN SIZE PLACEHOLDER 2.0
 *
 * Compatible with Build theme ProductForm.
 *
 * Shopify keeps a valid internal variant.
 * Customers see a placeholder until they choose a size.
 *
 * NL / EN / DE / FR
 *
 * No modifications to theme.js required.
 */

(function () {
  'use strict';

  const FORM_SELECTOR = 'form[data-product-form]';
  const SIZE_SELECTOR = '[data-unbegun-size-select]';

  const translations = {
    nl: {
      placeholder: 'Kies je maat',
      error: 'Kies eerst je maat.'
    },
    en: {
      placeholder: 'Select your size',
      error: 'Please select your size.'
    },
    de: {
      placeholder: 'Größe wählen',
      error: 'Bitte wähle zuerst deine Größe.'
    },
    fr: {
      placeholder: 'Choisir une taille',
      error: 'Veuillez choisir votre taille.'
    }
  };

  function language() {
    const code = (
      document.documentElement.lang || 'nl'
    ).slice(0, 2).toLowerCase();

    return translations[code] ? code : 'nl';
  }

  function translate(key) {
    return translations[language()][key];
  }

  function sizeSelect(form) {
    return form.querySelector(SIZE_SELECTOR);
  }

  function addButton(form) {
    return form.querySelector('[data-add-button]');
  }

  function paymentButtons(form) {
    return form.querySelectorAll(
      '.shopify-payment-button'
    );
  }

  function requestedVariant(form) {
    const params = new URLSearchParams(
      window.location.search
    );

    const id = params.get('variant');

    if (!id || !/^\d+$/.test(id)) {
      return false;
    }

    const variantSelect = form.querySelector(
      '[data-variant-select]'
    );

    if (!variantSelect) {
      return false;
    }

    return Array.from(variantSelect.options).some(
      option =>
        option.value === id &&
        !option.disabled
    );
  }

  function getState(form) {
    return form._unbegunSizeState || null;
  }

  function ensureStyles() {
    if (
      document.getElementById(
        'unbegun-size-placeholder-styles'
      )
    ) {
      return;
    }

    const style = document.createElement('style');

    style.id = 'unbegun-size-placeholder-styles';

    style.textContent = `
      .unbegun-size-placeholder-wrapper {
        position: relative;
      }

      .unbegun-size-placeholder-wrapper
      .unbegun-size-placeholder-label {
        position: absolute;
        top: 50%;
        left: 16px;
        right: 40px;
        transform: translateY(-50%);
        pointer-events: none;
        z-index: 1;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: #777;
        font: inherit;
        line-height: inherit;
      }

      .unbegun-size-placeholder-wrapper
      select.unbegun-size-unselected {
        color: transparent !important;
      }

      .unbegun-size-placeholder-wrapper
      select.unbegun-size-unselected option {
        color: #222 !important;
      }

      .unbegun-size-placeholder-wrapper
      select.unbegun-size-unselected:focus {
        outline-offset: 2px;
      }

      .unbegun-size-error {
        color: #c92a1d;
        font-size: 13px;
        line-height: 1.5;
        margin: 7px 0 0;
      }
    `;

    document.head.appendChild(style);
  }

  function removeOldPlaceholder(select) {
    Array.from(select.options).forEach(option => {
      if (option.value === '') {
        option.remove();
      }
    });
  }

  function firstRealOption(select) {
    return Array.from(select.options).find(
      option => option.value !== ''
    );
  }

  function createOverlay(select) {
    const wrapper = select.closest(
      '.select-wrapper'
    );

    if (!wrapper) {
      return null;
    }

    wrapper.classList.add(
      'unbegun-size-placeholder-wrapper'
    );

    let overlay = wrapper.querySelector(
      '.unbegun-size-placeholder-label'
    );

    if (!overlay) {
      overlay = document.createElement('span');

      overlay.className =
        'unbegun-size-placeholder-label';

      overlay.setAttribute(
        'aria-hidden',
        'true'
      );

      wrapper.appendChild(overlay);
    }

    overlay.textContent = translate(
      'placeholder'
    );

    return overlay;
  }

  function showError(form) {
    const select = sizeSelect(form);

    if (!select) return;

    let error = form.querySelector(
      '[data-unbegun-size-error]'
    );

    if (!error) {
      error = document.createElement('p');

      error.className = 'unbegun-size-error';

      error.dataset.unbegunSizeError = '';

      error.setAttribute('role', 'alert');

      select.closest('.select-wrapper')
        .insertAdjacentElement(
          'afterend',
          error
        );
    }

    error.textContent = translate('error');
    error.hidden = false;

    select.setAttribute(
      'aria-invalid',
      'true'
    );

    select.focus();
  }

  function clearError(form) {
    const error = form.querySelector(
      '[data-unbegun-size-error]'
    );

    if (error) {
      error.hidden = true;
    }

    const select = sizeSelect(form);

    if (select) {
      select.removeAttribute('aria-invalid');
    }
  }

  function isMissing(form) {
    const state = getState(form);

    if (!state) {
      return false;
    }

    return !state.chosen;
  }

  function update(form) {
    const state = getState(form);

    if (!state) return;

    const missing = !state.chosen;
    const select = state.select;
    const button = addButton(form);

    state.overlay.hidden = !missing;

    select.classList.toggle(
      'unbegun-size-unselected',
      missing
    );

    form.dataset.unbegunSizeMissing =
      String(missing);

    if (button) {
      if (missing) {
        button.disabled = true;

        button.setAttribute(
          'aria-disabled',
          'true'
        );
      } else {
        button.removeAttribute(
          'aria-disabled'
        );

        /*
         * The theme controls availability.
         * Do not force-enable sold-out variants.
         */
      }
    }

    paymentButtons(form).forEach(element => {
      element.hidden = missing;
      element.style.display = missing
        ? 'none'
        : '';
    });
  }

  function reset(form) {
    const state = getState(form);

    if (!state) return;

    const first = firstRealOption(
      state.select
    );

    if (first) {
      state.select.value = first.value;
    }

    state.chosen = false;

    clearError(form);
    update(form);
  }

  function markChosen(form) {
    const state = getState(form);

    if (!state) return;

    if (state.select.value === '') {
      return;
    }

    state.chosen = true;

    clearError(form);

    requestAnimationFrame(() => {
      update(form);
    });
  }

  function prepareSelection(form) {
    const state = getState(form);

    if (!state || state.chosen) {
      return;
    }

    /*
     * Temporarily clear the selection when
     * the customer opens the dropdown.
     *
     * This ensures choosing the first real
     * option also produces a change event.
     *
     * No change event is dispatched here.
     */

    state.select.selectedIndex = -1;
  }

  function restoreIfUnchosen(form) {
    const state = getState(form);

    if (!state || state.chosen) {
      return;
    }

    const first = firstRealOption(
      state.select
    );

    if (first) {
      state.select.value = first.value;
    }

    update(form);
  }

  function initialize(form) {
    if (
      !form ||
      form._unbegunSizeState
    ) {
      return;
    }

    const select = sizeSelect(form);

    if (!select) return;

    ensureStyles();

    /*
     * Remove the disabled placeholder.
     *
     * Safari may otherwise visually select
     * the first enabled option even when the
     * disabled placeholder is marked selected.
     */

    removeOldPlaceholder(select);

    const first = firstRealOption(select);

    if (!first) return;

    const validVariant = requestedVariant(form);

    /*
     * Ensure ProductForm has a valid option
     * during initialization.
     */

    if (!validVariant) {
      select.value = first.value;
    }

    const overlay = createOverlay(select);

    if (!overlay) return;

    form._unbegunSizeState = {
      select: select,
      overlay: overlay,
      chosen: validVariant
    };

    select.addEventListener(
      'pointerdown',
      () => prepareSelection(form)
    );

    select.addEventListener(
      'keydown',
      event => {
        if (
          event.key === ' ' ||
          event.key === 'Enter' ||
          event.key === 'ArrowDown' ||
          event.key === 'ArrowUp'
        ) {
          prepareSelection(form);
        }
      }
    );

    select.addEventListener(
      'change',
      () => markChosen(form)
    );

    select.addEventListener(
      'blur',
      () => restoreIfUnchosen(form)
    );

    /*
     * Prevent a missing selection from
     * reaching ProductForm's submit handler.
     */

    form.addEventListener(
      'submit',
      event => {
        if (!isMissing(form)) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        showError(form);
      },
      true
    );

    /*
     * The theme can update the disabled
     * state after changing a variant.
     */

    const button = addButton(form);

    if (button) {
      const observer = new MutationObserver(
        () => {
          if (
            isMissing(form) &&
            !button.disabled
          ) {
            button.disabled = true;
          }
        }
      );

      observer.observe(button, {
        attributes: true,
        attributeFilter: ['disabled']
      });
    }

    update(form);
  }

  function initializeAll(root) {
    const context = root || document;

    if (
      context.matches &&
      context.matches(FORM_SELECTOR)
    ) {
      initialize(context);
    }

    if (context.querySelectorAll) {
      context.querySelectorAll(
        FORM_SELECTOR
      ).forEach(initialize);
    }
  }

  /*
   * Public API for the custom-size module.
   */

  window.UnbegunSizePlaceholder = {
    reset: reset,
    update: update,
    isMissing: isMissing,
    select: markChosen
  };

  /*
   * Shopify section support.
   */

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => initializeAll(document)
    );
  } else {
    initializeAll(document);
  }

  document.addEventListener(
    'shopify:section:load',
    event => initializeAll(event.target)
  );

})();
